import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '@homeaway/react-tooltip';

import {useComponent} from './hooks/useComponent';

import '../SearchDay/SearchDay.less';
import './SearchSelectDateHintDay.less';

function SearchSelectDateHintDay(props) {
    const {
        className,
        contentClassName,
        labelClassName,
        valueClassName,
        tooltipPortalClassName,
        tooltipWrapperClassName,
        tooltipContent,
        tooltipIsOpen,
        tooltipParentNode,
        onTooltipClose,
        onTooltipOpen,
        day,
        ariaLabelDate
    } = useComponent(props);

    return (
        <div className={className} aria-hidden>
            <Tooltip
                centered
                closeOnOutsideClick={false}
                content={tooltipContent}
                fadeOut={false}
                fadeOutDuration={0}
                isOpen={tooltipIsOpen}
                onClose={onTooltipClose}
                onOpen={onTooltipOpen}
                parentNode={tooltipParentNode}
                portalClassName={tooltipPortalClassName}
                trigger="none"
                wrapperClassName={tooltipWrapperClassName}
                wrappingMethod="block"
            >
                <dl className={contentClassName}>
                    <dt className={labelClassName}>
                        {day}
                    </dt>
                    <dd className={valueClassName}>
                        {ariaLabelDate}
                    </dd>
                </dl>
            </Tooltip>
        </div>
    );
}

SearchSelectDateHintDay.propTypes = {
    ariaLabelDate: PropTypes.string,
    dateString: PropTypes.string,
    dayData: PropTypes.shape({
        showSelectDateHint: PropTypes.bool
    }),
    day: PropTypes.number,
    isPast: PropTypes.bool,
    isToday: PropTypes.bool,
    selectDateHintMessage: PropTypes.string
};

SearchSelectDateHintDay.defaultProps = {
    ariaLabelDate: '',
    dateString: '',
    dayData: {
        showSelectDateHint: false
    },
    day: 0,
    isPast: false,
    isToday: false
};

SearchSelectDateHintDay.canClick = function canClick(props) {
    const {
        dayData: {
            inPast
        },
        isPast
    } = props;

    return !(isPast || inPast);
};

// SearchSelectDateHintDay.whyDidYouRender = true;

export {SearchSelectDateHintDay};
